export default [
    {
        path: "/data-import",
        name: "DataImport",
        component: () =>
            import ("@/views/dataImport/DataImport.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/inno-dot",
        name: "InnoDOT",
        component: () =>
            import ("@/views/innoDots/InnoDots.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/presumptive-export",
        name: "presumptive-export",
        component: () =>
            import ("@/views/presumptive/Export.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/side-effect-export",
        name: "side-effect-export",
        component: () =>
            import ("@/views/side-effect/Export.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/outcome-export",
        name: "outcome-export",
        component: () =>
            import ("@/views/outcome/Export.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/dots-patient-export",
        name: "dots-patient-export",
        component: () =>
            import ("@/views/dotsPatient/Export.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/enroll-patient-export",
        name: "enroll-patient-export",
        component: () =>
            import ("@/views/patient/PatientEnrollExport.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/familymember-export",
        name: "familymember-export",
        component: () =>
            import ("@/views/presumptive/FamilymemberExport.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/ci-export",
        name: "ci-export",
        component: () =>
            import ("@/views/presumptive/CiExport.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/complementary-export",
        name: "complementary-export",
        component: () =>
            import ("@/views/patient/ComplementaryPatientExport.vue"),
        meta: {
            forAuth: true,
        },
    },
    {
        path: "/dots-visit-export",
        name: "dots-visit-export",
        component: () =>
            import ("@/views/dotsPatient/VisitExport.vue"),
        meta: {
            forAuth: true,
        },
    },
];